<template>
  <div id="supplier-layout" class="min-vh-100 bg-light">
    <the-supplier-header />
    
    <main id="main" class="pt-52">
      <router-view />
    </main>

    <footer class="bg-white border-top py-24 mt-48">
      <div class="container-xl">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-16">
          <div class="text-muted small">
            &copy; {{ new Date().getFullYear() }} WAW Travels. All rights reserved.
          </div>
          <div class="d-flex gap-24">
            <a href="#" class="text-muted text-decoration-none small">Terms</a>
            <a href="#" class="text-muted text-decoration-none small">Privacy</a>
            <a href="#" class="text-muted text-decoration-none small">Support</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TheSupplierHeader from '@/components/layout/parts/TheSupplierHeader.vue';

export default defineComponent({
  name: 'VSupplierLayout',
  components: {
    TheSupplierHeader,
  },
});
</script>

<style lang="scss" scoped>
#supplier-layout {
  display: flex;
  flex-direction: column;
}

#main {
  flex: 1 0 auto;
}

footer {
  flex-shrink: 0;
}
</style>
